import React from 'react';
import { connect } from 'react-redux';
import pickBy from 'lodash/pickBy';
import includes from 'lodash/includes';
import values from 'lodash/values';
import sortBy from 'lodash/sortBy';
import intersection from 'lodash/intersection';
import { selectors as apiSelectors } from 'zender-api-client';
import ShoutboxContent from './ShoutboxVisualization.component';

const messageSelector = (state) => {
	const {
		submission: {
			data,
			selected,
		},
	} = state;
	const starredShouts = apiSelectors.shoutbox.starredShoutsSelector(state);
	const selectedIds = intersection(data, selected);
	const shts = values(pickBy(starredShouts, shout => includes(selectedIds, shout.id)));
	// console.log('### shts ###>', JSON.stringify(map(shts, 'id'), null, '	'));
	return sortBy(shts, item => selected.indexOf(item.id));
};

const mapStateToProps = (state) => {
	const {
		submission: {
			focussed,
			itemToRemove,
			selected,
		},
	} = state;
	return ({
		messages: messageSelector(state),
		focussed,
		itemToRemove,
		selected,
	});
};

export default connect(
	mapStateToProps
)(ShoutboxContent);



// WEBPACK FOOTER //
// ./src/ui/interaction/children/shoutboxvisualization/ShoutboxVisualization.container.js